<!-- Author ミィン -->
<!-- 口座振替納付書 -->

<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t('general.add')}}
        </el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="text" class="el-icon-view" @click="preview()">{{$t('general.preview')}}</el-button>
      </el-form-item> -->
    </el-form>

    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('labor_ins_account.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('labor_ins_account.bank_account')" align="center">
        <el-table-column :label="$t('labor_ins_account.bank_code')" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('labor_ins_account.bank_store_code')" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_store_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('labor_ins_account.account_name_kana')" align="center" width="135">
          <template slot-scope="scope">
            <span>{{ scope.row.account_name_kana }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('labor_ins_account.account_name')" align="center" width="135">
          <template slot-scope="scope">
            <span>{{ scope.row.account_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('labor_ins_account.bank_transfer_type')" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_transfer_type }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column :label="$t('labor_ins_account.bank_transfer_start_date')" align="center">
        <el-table-column :label="$t('labor_ins_account.era')" align="center" width="62">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_transfer_start_date_era }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('labor_ins_account.year')" align="center" width="62">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_transfer_start_date_year }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('labor_ins_account.term')" align="center" width="62">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_transfer_start_date_term }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column :label="$t('labor_ins_account.submit_date')" align="center" width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.submit_date }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t('general.delete')}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t('general.print')}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview()" plain></el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- Add  -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="75%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="220px" class="demo-ruleForm" size="medium">
        <el-input type="hidden" v-model="ruleForm.id" />

        <el-collapse>
          <el-collapse-item :title="$t('labor_ins_account.designated_deposit_account')" name="1" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('labor_ins_account.employee_id')+':'" prop="employee_id" style="margin-left:30px">
                    <el-select v-model="ruleForm.employee_id" style="margin-left:10px;width: 185px" size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" @change="employeeIdSelected">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.name')+':'" prop="name" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.bank_code')+':'" prop="bank_code" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_code" size="mini" style="margin-left:10px;width: 185px" placeholder="0005"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.bank_store_code')+':'" prop="bank_store_code" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_store_code" size="mini" style="margin-left:10px;width: 185px" placeholder="001"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('labor_ins_account.bank_transfer_type')+':'" prop="bank_transfer_type">
                    <el-select v-model="ruleForm.bank_transfer_type" style="margin-left:10px;width: 185px" size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in bank_transfer_type_list" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.account_name_kana')+':'" prop="account_name_kana">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account_name_kana" size="mini" style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.account_name')+':'" prop="account_name_kana">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account_name" size="mini" style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('labor_ins_account.transfer_payment_deadline')" name="2" class="title">
            <el-row>
              <el-col :span="20">
                <div>
                  <el-form-item :label="$t('labor_ins_account.bank_transfer_start_date_era')+':'" prop="bank_transfer_start_date_era" style="margin-left:30px">
                    <el-select v-model="ruleForm.bank_transfer_start_date_era" clearable style="margin-left:10px;width: 185px" size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in bank_transfer_start_date_era" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.bank_transfer_start_date_year')+':'" prop="bank_transfer_start_date_year" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_transfer_start_date_year" size="mini" style="margin-left:10px;width: 185px" placeholder="例：2020"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.bank_transfer_start_date_term')+':'" prop="bank_transfer_start_date_term" style="margin-left:30px">
                    <el-select v-model="ruleForm.bank_transfer_start_date_term" clearable style="margin-left:10px;width: 185px" size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in bank_transfer_start_date_term" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                    <el-button class="el-icon-info" type="text" @click="open1">{{$t("general.hint")}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.submit_date')+':'" prop="submit_date" style="margin-left:30px">
                    <el-date-picker v-model="ruleForm.submit_date" size="mini" value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="75%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="220px" class="demo-ruleForm" size="medium" :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />

        <el-collapse>
          <el-collapse-item :title="$t('labor_ins_account.designated_deposit_account')" name="1" class="title">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('labor_ins_account.employee_id')+':'" prop="employee_id" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.employee_id" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.name')+':'" prop="name" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini" style="margin-left:10px;width: 185px" readonly="readonly"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.bank_code')+':'" prop="bank_code" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_code" size="mini" style="margin-left:10px;width: 185px" placeholder="0005"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.bank_store_code')+':'" prop="bank_store_code" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_store_code" size="mini" style="margin-left:10px;width: 185px" placeholder="001"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('labor_ins_account.bank_transfer_type')+':'" prop="bank_transfer_type">
                    <el-select v-model="ruleForm.bank_transfer_type" style="margin-left:10px;width: 185px" size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in bank_transfer_type_list" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.account_name_kana')+':'" prop="account_name_kana">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account_name_kana" size="mini" style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.account_name')+':'" prop="account_name_kana">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.account_name" size="mini" style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item :title="$t('labor_ins_account.transfer_payment_deadline')" name="2" class="title">
            <el-row>
              <el-col :span="20">
                <div>
                  <el-form-item :label="$t('labor_ins_account.bank_transfer_start_date_era')+':'" prop="bank_transfer_start_date_era" style="margin-left:30px">
                    <el-select v-model="ruleForm.bank_transfer_start_date_era" clearable style="margin-left:10px;width: 185px" size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in bank_transfer_start_date_era" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.bank_transfer_start_date_year')+':'" prop="bank_transfer_start_date_year" style="margin-left:30px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.bank_transfer_start_date_year" size="mini" style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.bank_transfer_start_date_term')+':'" prop="bank_transfer_start_date_term" style="margin-left:30px">
                    <el-select v-model="ruleForm.bank_transfer_start_date_term" clearable style="margin-left:10px;width: 185px" size="mini" :placeholder="$t('general.please_select')">
                      <el-option v-for="item in bank_transfer_start_date_term" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                    <el-button class="el-icon-info" type="text" @click="open1">{{$t("general.hint")}}</el-button>
                  </el-form-item>

                  <el-form-item :label="$t('labor_ins_account.submit_date')+':'" prop="submit_date" style="margin-left:30px">
                    <el-date-picker v-model="ruleForm.submit_date" size="mini" value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" placeholder></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}</el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      labelPosition: "left",
      bank_transfer_type_list: [{
        id: 1,
        name: "1.新規",
      },
      {
        id: 2,
        name: "2.更新",
      },
      ],
      bank_transfer_start_date_term: [{
        id: 1,
        name: "1期",
      },
      {
        id: 2,
        name: "2期",
      },
      {
        id: 2,
        name: "3期",
      },
      ],
      bank_transfer_start_date_era: [{
        id: 1,
        name: "昭和",
      },
      {
        id: 2,
        name: "平成",
      },
      {
        id: 3,
        name: "令和",
      },
      ],
      ruleForm: {
        id: "",
        bank_code: "",
        bank_store_code: "",
        account_name_kana: "",
        account_name: " ",
        bank_transfer_type: "",
        bank_transfer_start_date_era: "",
        bank_transfer_start_date_year: "",
        bank_transfer_start_date_term: "",
        date: "",
        submit_date: "",
        employee_id: "",
        name: "",
      },
      rules: {
        employee_id: [{
          required: true,
          message: this.$t("labor_ins_account.enter_employee_id"),
          trigger: "blur",
        },],
        bank_code: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
        bank_store_code: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
        account_name_kana: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
        account_name: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
        bank_transfer_type: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
        name: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
      },
      tableData: [],
      search: "",
      dialogVisible: false,
      dialogUpdate: false,
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,
      empList: [],
      empList1: [],
      emp: {
        id: "",
        employee_id: "",
        name: "",
        name_rm: "",
        name_frgn: "",
        post_code: "",
        birthday: "",
        birthday: "",
        gender: "",
        email: "",
        mynum: "",
        work_status: "",
        begin_date: "",
        end_date: "",
        cause: "",
        employee_type: "",
        title: "",
        work_content: "",
        address1: "",
        address2: "",
        address3: "",
        address_kn1: "",
        address_kn2: "",
        address_kn3: "",
        tel: "",
        bank_name: "",
        bank_branch: "",
        deposit_type: "",
        account: "",
        account_name: "",
        emp_insuranceID: "",
        emp_ins_begin_day: "",
        emp_ins_end_day: "",
        pensionID: "",
        health_insuranceID: "",
        basic_pensionID: "",
        salary_changeday: "",
        salary_month: "",
        commuting_fee: "",
        nation: "",
        resident: "",
        resident_code: "",
      },
    };
  },
  methods: {
    open1() {
      const h = this.$createElement;
      this.$notify({
        title: "振替納付期日の納期（期）について",
        message: h(
          "i", {
          style: "color: teal",
        },
          "第1期（成立した日～7.31）第2期（8.1～11.30）第3期（12.1～3.31）"
        ),
      });
    },
    employeeIdSelected() {
      console.log(this.ruleForm.employee_id);
      let postData = this.qs.stringify({
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListEmpList",
        data: postData,
      })
        .then((response) => {
          // console.log(response.data);
          this.empList1 = response.data;
          this.ruleForm.name = this.empList1[0].name;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    preview() {
      var uid = window.localStorage.getItem('LoginUserId');
      window.open("/pdf/口座振替納付書-" + "uid=" + uid + ".pdf");
    },
    printPDF(index, row) {
      let postData = this.qs.stringify({
        id: row.id,
      });
      this.axios({
        method: "post",
        url: "/LaborInsAccountPDF",
        data: postData,
      })
        .then((response) => {
          this.handleCurrentChange();
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
            setTimeout(()=>{this.preview();},700);
          
          
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          console.log(error);
        });
    },
    handleEdit(index, row) {
      this.dialogUpdate = true;
      this.ruleForm = Object.assign({}, row);
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          this.emptyUserData();
          done();
        })
        .catch((_) => { });
    },
    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage,
      });
      this.axios({
        method: "post",
        url: "/pageLaborInsAccount",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    s1_cancel(ruleForm) {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();
      this.$refs[ruleForm].resetFields();
    },
    cancel() {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();
    },
    emptyUserData() {
      this.ruleForm = {
        id: "",
        bank_code: "",
        bank_store_code: "",
        account_name_kana: "",
        account_name: " ",
        bank_transfer_type: "",
        bank_transfer_start_date_era: "",
        bank_transfer_start_date_year: "",
        bank_transfer_start_date_term: "",
        submit_date: "",
        employee_id: "",
        name: "",
      };
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("general.close_comfirm"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteLaborInsAccount",
            data: postData,
          })
            .then((response) => {
              this.getPages();
              this.currentPage = 1;
              this.axios
                .post("/pageLaborInsAccount")
                .then((response) => {
                  this.tableData = response.data;
                })
                .catch((error) => {
                  console.log(error);
                });
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed"),
              });
              // console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },
    addUser(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            bank_code: this.ruleForm.bank_code,
            bank_store_code: this.ruleForm.bank_store_code,
            account_name_kana: this.ruleForm.account_name_kana,
            account_name: this.ruleForm.account_name,
            bank_transfer_type: this.ruleForm.bank_transfer_type,
            bank_transfer_start_date_era: this.ruleForm
              .bank_transfer_start_date_era,
            bank_transfer_start_date_year: this.ruleForm
              .bank_transfer_start_date_year,
            bank_transfer_start_date_term: this.ruleForm
              .bank_transfer_start_date_term,
            submit_date: this.ruleForm.submit_date,
            employee_id: this.ruleForm.employee_id,
          });
          this.axios({
            method: "post",
            url: "/insertLaborInsAccount",
            data: postData,
          })
            .then((response) => {
              this.axios
                .post("/pageLaborInsAccount")
                .then((response) => {
                  this.tableData = response.data;
                  this.currentPage = 1;
                  this.$message({
                    type: "success",
                    message: this.$t("general.add_completed"),
                  });
                })
                .catch((error) => {
                  this.$message({
                    type: "warning",
                    message: this.$t("general.add_failed"),
                  });
                  console.log(error);
                });
              this.getPages();
              this.dialogVisible = false;
              // console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          // console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    updateUser(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            bank_code: this.ruleForm.bank_code,
            bank_store_code: this.ruleForm.bank_store_code,
            account_name_kana: this.ruleForm.account_name_kana,
            account_name: this.ruleForm.account_name,
            bank_transfer_type: this.ruleForm.bank_transfer_type,
            bank_transfer_start_date_era: this.ruleForm
              .bank_transfer_start_date_era,
            bank_transfer_start_date_year: this.ruleForm
              .bank_transfer_start_date_year,
            bank_transfer_start_date_term: this.ruleForm
              .bank_transfer_start_date_term,
            submit_date: this.ruleForm.submit_date,
            employee_id: this.ruleForm.employee_id,
          });
          this.axios({
            method: "post",
            url: "/updateLaborInsAccount",
            data: postData,
          })
            .then((response) => {
              this.handleCurrentChange();
              this.s1_cancel(ruleForm);
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
              // console.log(response);
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          // console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    getPages() {
      this.axios
        .post("/rowsLaborInsAccount")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshData() {
      location.reload();
    },
  },
  created() {
    this.axios
      .post("/pageLaborInsAccount")
      .then((response) => {
        // console.log(response.data);
        this.tableData = response.data;
      })
      .catch((error) => {
        // this.show = false;
        // this.$message({ type: 'error', message: '開発中です。' });
        // console.log(error);
      });

    this.axios
      .post("/rowsLaborInsAccount")
      .then((response) => {
        this.total = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.axios
      .post("/ListEmpListForInsNameChange")
      .then((response) => {
        // console.log(response.data);
        this.empList = response.data;
        // console.log(this.empList);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>


<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  width: 90px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>
<style scoped>
.search_name {
  width: 200px;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.style1 {
  margin-right: 145px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/LaborInsAccount.vue